<template>
  <div class="box box--highlight">
    <div class="columns is-gapless">
      <div class="column is-narrow is-flex">
        <div class="tier is-flex">
          <div class="tier__icon">
            <img :src="tierIcon" :alt="`${summoner.rank} icon`">
          </div>
        </div>
      </div>
      <div class="column is-flex">
        <div class="summoner is-flex">
          <div class="summoner__name">{{ summoner.name }}</div>
          <div v-if="summoner.rank" class="summoner__rank">{{ summoner.rank }}, {{ summoner.league_points }} LP</div>
        </div>
      </div>
      <div class="column is-narrow is-flex">
        <div class="summoner-score is-flex">
          <div class="summoner-score__value">{{ summoner.score }}</div>
          <div class="summoner-score__subtitle">Leaguepoints Score</div>
          <QueueSwitcher></QueueSwitcher>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const tierIcons = require.context('../assets/tier-icons')
import QueueSwitcher from '@/components/QueueSwitcher'

export default {
  components: {
    QueueSwitcher,
  },

  props: {
    summoner: {
      type: Object,
      required: true,
    },
  },

  computed: {
    tierIcon () {
      let tier = this.summoner.tier ? this.summoner.tier.toLowerCase() : 'unranked'

      return tierIcons(`./${tier}.png`)
    },
  },
}
</script>

<style lang="sass" scoped>
@import '~bulma/sass/utilities/variables'
@import '~bulma/sass/utilities/mixins'

.column
  justify-content: center

.tier
  justify-content: center

  &__icon
    height: 150px
    width: 150px

.summoner,
.summoner-score
  flex-direction: column
  justify-content: center
  text-align: center

.summoner
  margin-bottom: 2rem

.summoner__name
  font-size: 2.5rem
  font-weight: 500

.summoner__rank
  font-weight: 500

.summoner-score__value
  font-weight: 600
  letter-spacing: 1px
  font-size: 3rem
  line-height: 1

.summoner-score__subtitle
  font-size: .9rem
  line-height: 1

+tablet
  .tier__icon
    margin-right: 60px
    text-align: center

    > img
      max-height: 100%

  .summoner
    text-align: left
    margin-bottom: 0

  .column
    justify-content: flex-start
</style>



// WEBPACK FOOTER //
// SummonerBanner.vue?4a167ac6